import PropTypes from 'prop-types'

const StoreItem = ({
  image,
  name,
  address,
  phones,
  schedule,
  url
}) => {
  const { weekdays, sunday } = schedule

  return (
    <li className="row border-bottom no-padding margin-x-small">
      <a href={ url }>
        <div className="col-md-6 col-xl-2 hidden-medium no-padding">
          <img className="padding-y image" src={ image } />
        </div>
        <div className="col-xs-12 col-md-6 col-xl-10">
          <div className="store-item-text padding-left">
            <h5 className="store-item-name heading-5 color-primary">
              { name }
            </h5>
            <div className="store-item-description">
              <p className="store-address no-margin">{ address }</p>
              <p className="store-phones no-margin">Fone { phones }</p>
              <p className="store-schedule no-margin">
                Segunda à sábado { weekdays[0] } - { weekdays[1] } / domingos e feriados { sunday[0] } - { sunday[1] }
              </p>
            </div>
          </div>
        </div>
      </a>
    </li>
  )
}

StoreItem.propTypes = {
  image: PropTypes.string,
  name: PropTypes.string,
  address: PropTypes.string,
  phones: PropTypes.string,
  schedule: PropTypes.shape({
    sunday: PropTypes.arrayOf(PropTypes.string),
    weekdays: PropTypes.arrayOf(PropTypes.string)
  }),
  url: PropTypes.string
}

export default StoreItem
